module.exports = __webpack_public_path__ + "static/media/man-image.c438a104.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Icons/man-image.png
// module id = 1004
// module chunks = 2